import moment from "moment";
import { SignatureFieldRef } from "@/Features";

// Helper function to create signature object
export const createSignature = (
  signatureRef: React.RefObject<SignatureFieldRef>,
  ipAddress: string | null,
  currentUser: any
) => {
  if (!signatureRef.current || signatureRef.current.isEmpty()) {
    return null;
  }

  return {
    signature: signatureRef.current.getSignature() || "",
    signer: currentUser.full_name,
    timestamp: moment().toISOString(),
    userAgent: window.navigator.userAgent,
    ip_address: ipAddress || "",
    monolith_user: {
      first_name: currentUser.first_name,
      last_name: currentUser.last_name,
      full_name: currentUser.full_name,
      email: currentUser.email,
      title: currentUser.title,
      user_id: currentUser.user_id,
    },
    esig: signatureRef.current.isESignature || false,
  };
};
